const en = {
  helmet_index_description : 'Find picnic areas around you',
  home: 'Zones',
  ajustes: 'Add zones',
  home_cerca: 'Close to me',
  menu_listado: 'List',
  menu_mapa: 'Map',
  detalles_aseos: 'WC',
  detalles_aseos_descripcion: 'If there are wc in the area',
  detalles_banyo: 'Swimming area',
  detalles_banyo_descripcion: 'Lake, swimming pool, beach, ...',
  detalles_zona_infantil: 'Children area',
  detalles_zona_infantil_descripcion: 'Slides, swings, park, ...',
  detalles_mesas: 'Tables',
  detalles_mesas_descripcion: 'If there are tables in the area',
  detalles_alimentacion: 'Meals',
  detalles_alimentacion_descripcion: 'Bar, restaurant, shop, ...',
  add_zonas_title: 'Do you want to add more zones?',
  add_zonas_1: 'Click ',
  add_zonas_2: 'here',
  add_zonas_3: 'and fill in the form',
  add_zonas_4: 'Thank you. Other users will enjoy with your contributtion.',
  add_zona: 'Add zone',
  add_zona_descripcion: 'Fill in the form and add the zone to map.\nThank you. Other users will enjoy with your contributtion.',
  nueva_zona_nombre: 'Name',
  nueva_zona_descripcion: 'Description',
  nueva_zona_ciudad: 'City',
  nueva_zona_pais: 'Country',
  nueva_zona_zona_banyo: 'Is there any lake, beach or swimming pool?',
  nueva_zona_bar: 'Is there any bar or restaurant?',
  nueva_zona_zona_infantil: 'Is there any playground for children?',
  nueva_zona_aseos: 'How many bathrooms are there?',
  nueva_zona_mesas: 'How many tables are there?',
  nueva_zona_fuentes: 'How many fountains are there?',
  nueva_zona_barbacoa: 'Is there a zone for barbaque?',
  nueva_zona_tipo_suelo: 'Which kind of ground is there?',
  nueva_zona_url_imagen: 'Add an image link',
  nueva_zona_add_btn: "Add zone",
  si: "Yes",
  no: "No",
  cesped: "grass",
  tierra: "land",
  piedras: "stones",
  arena: "sand",
  asfalto: "asphalt",
  nueva_zona_error_titulo: "Warning",
  nueva_zona_error_nombre: "You must fill in a name",
  nueva_zona_error_ciudad: "You must fill in a city",
  nueva_zona_error_país: "You must fill in the name of a country",
  nueva_zona_error_aseos: "Put a valid number of bathrooms",
  nueva_zona_error_fuentes: "Put a valid number of fountains",
  nueva_zona_error_mesas: "Put a valid number of tables",
  nueva_zona_creada: "Zone was created 👍🏽",
  info_zona_error_descripcion: "Error description should be clear and you must try to give a solution.\nIf the error is the position, the tables number, ..., send us the right data.\nThank you so much.",
  info_zona_error_titulo: "Report an error",
  info_zona_error_boton: "Send",
  info_zona_error_placeholder: "Write here the error description",
  info_zona_error_enviado: "It has sended correctly. Thanks",
  info_zona_error_error: "Sorry, Write an error description.",
  bienvenida_texto: "If you know a zone and you don't see it at the map, do a long press on the place where you want to add the zone and a form will open to fill in data. When you have sended it the new zone will appear at the map.\n\n" +
    "On the detail of a zone, you can click on the map icon to open google maps with the indications to drive to the zone or at the megaphone to report a zone error.\n\nWith this app you can find picnic zones you have near to you.\nYou can help sharing new zones and anybody will be able to enjoy them.",
  bienvenida_cerrar: "Close",
  bienvenida_no_mostrar: "Don't show again",
  change_detail_image_descripcion: "Escribe la URL de la imagen que quieras enviar",
  change_detail_image_boton: "Enviar url",
  change_detail_imageplaceholder: "Escribe aquí la Url",
  change_detail_image_titulo: "Image received",
  change_detail_image_enviado: "The image has been added. Thanks.",
  change_detail_image_error_titulo: "Atención",
  change_detail_image_error: "Por favor, introduce la url de la imagen.",
  change_detail_image_foto: "Upload a new picture",
  change_detail_image_foto_error: "An error ocurred when we tried to get the photo.\nCheck the app permissions.",
  select_language: "Select language",
  btn_ok: "OK",
  title_detalle: "Detail",
  translate_to: "Translate to English",
  share_title: "Share the area",
  share_text: "Take a look to this picnic area",
  share_thanks: "Thanks for share the picnic area",
  share_copied_to_clipboard: "The area url has been copied to the clipboard",
  error_location_denied: "If you want to use the location you must activate it in the settings",
  error_location: "Error trying to locate the user"
};
export default en;